export default {
  SET_ONLINE(state, payload) {
    state.online = payload;
  },
};
